/**
 * Shop-by-age chips (collection page, filter mode).
 *
 * The chips own no state. A click ticks the matching size checkboxes that already
 * live inside the theme's facet form, then fires a single `change` event so
 * FacetForm rebuilds the URL from FormData and runs its normal AJAX swap.
 * Server-rendered markup stays the source of truth for active state and counts —
 * after each swap the row is re-rendered from the response.
 *
 * The facet parameter is not hardcoded. This store shows the size filter under a
 * Norwegian label ('Størrelse') while the option behind it is still named Size, and
 * either could be renamed in the admin, so the snippet reads the live parameter off
 * the collection's own facets and hands it over on `data-size-param`.
 *
 * Setting `.checked` in script fires no `change` event, which is what lets a
 * multi-value bucket toggle several inputs and still submit exactly once.
 */
(function () {
  const CHIPS_ID = 'AgeChips';

  function sizeInputs(root, param) {
    return Array.from(root.querySelectorAll('input[name="' + param + '"]'));
  }

  // Desktop sidebar and mobile drawer are two separate forms, both always in the DOM.
  // Update every one so whichever is visible reflects the chip, and submit through one.
  function facetForms(param) {
    return Array.from(document.querySelectorAll('form[is="facet-form"]')).filter(
      (form) => sizeInputs(form, param).length > 0
    );
  }

  function onClick(event) {
    const chip = event.target.closest('[data-age-chip]');
    if (!chip || chip.disabled) return;

    const container = chip.closest('[data-age-chips]');
    if (!container || container.dataset.mode !== 'filter') return;

    const param = container.dataset.sizeParam;
    if (!param) return;

    const values = (chip.dataset.values || '').split(',').filter(Boolean);
    if (!values.length) return;

    const forms = facetForms(param);
    if (!forms.length) return;

    event.preventDefault();

    const turnOn = chip.getAttribute('aria-pressed') !== 'true';
    let trigger = null;

    forms.forEach((form) => {
      sizeInputs(form, param).forEach((input) => {
        if (values.indexOf(input.value) === -1) return;
        input.checked = turnOn;
        if (form === forms[0]) trigger = input;
      });
    });

    if (!trigger) return;

    // Optimistic paint so the chip answers the tap before the fetch resolves.
    // Overwritten by the server-rendered row a moment later.
    chip.setAttribute('aria-pressed', String(turnOn));
    chip.classList.toggle('is-active', turnOn);

    trigger.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onFacetUpdate(data) {
    const current = document.getElementById(CHIPS_ID);
    if (!current || !data || !data.responseText) return;

    const parsed = new DOMParser().parseFromString(data.responseText, 'text/html');
    const next = parsed.getElementById(CHIPS_ID);
    if (next) current.innerHTML = next.innerHTML;
  }

  function subscribe() {
    if (!window.FoxTheme || !window.FoxTheme.pubsub) return false;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, onFacetUpdate);
    return true;
  }

  // Delegated, so re-rendering the row never leaves a dead chip behind.
  document.addEventListener('click', onClick);

  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe);
  }
})();
